<!--
 @description 环境权限管理-新增、编辑页
 @date 2018/11/14
-->
<template>
  <div class="hanlerEnvauthority__content">
    <g-back :history="history" class="ilb"></g-back>
    <el-button 
      type="primary"
      style="margin-left: 10px;"
      @click="saveAuth" 
      v-g-rac="gRac('handlerEnvauthority@save')" 
      v-text="$t('common.save')"></el-button>
    <el-form ref="saveForm" :model="saveForm" label-width="80px" :rules="formRule">
      <el-form-item :label="$t('envauthority.group')" prop="group">
        <el-select v-model="saveForm.group" filterable>
          <el-option v-for="(item, key) in select_department" :label="item" :value="key" :key="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('envauthority.user')" prop="name">
        <el-input v-model="saveForm.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('envauthority.repertory')">
        <el-button type="primary" 
          @click="openResourceDia" 
          v-g-rac="gRac('handlerEnvauthority@addResource')" 
          v-text="$t('envauthority.addResource')"></el-button>
        <div style="margin-top: 10px;" v-for="(resourceItem, index) in resourceList" :key="resourceItem.flagId + index">
          <div v-text="select_resource[resourceItem.flagId]" 
            v-show="resourceItem.data && resourceItem.data.length > 0"></div>
          <table style="margin-top: 10px;" v-show="resourceItem.data && resourceItem.data.length > 0">
            <thead>
              <tr>
                <th class="t-border" v-text="$t('envauthority.authority')"></th>
                <th class="t-border" 
                  v-for="(item, index) in resourceItem.parton" 
                  :key="index"
                  v-text="item"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in resourceItem.data" :key="item.id">
                <td class="t-border">{{ item.auth | auth }}</td>
                <td class="t-border" 
                  v-for="(_item, index) in resourceItem.parton"
                  v-show="index !== 'operate'"
                  :key="index"
                  v-text="item[index]"
                  :title="item[index]"></td>
                <td class="t-border">
                  <span class="t-border-btn" v-text="$t('common.delete')" @click="deleteResource(item)"></span>
                  <span class="t-border-btn" v-text="$t('common.edit')" @click="editResourceAuth(item)"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </el-form-item>
      <el-form-item :label="$t('envauthority.machine')">
        <el-button type="primary" 
          @click="openHostDia" 
          v-g-rac="gRac('handlerEnvauthority@addMachines')" 
          v-text="$t('envauthority.addHost')"></el-button>
        <table style="margin-top: 10px;" v-show="machinesList.length > 0">
            <thead>
              <tr>
                <th class="t-border" v-text="$t('envauthority.authority')"></th>
                <th class="t-border" v-text="'IP'"></th>
                <th class="t-border" v-text="$t('envauthority.operate')"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in machinesList" :key="item.ip">
                <td class="t-border">{{ item.auth | auth }}</td>
                <td class="t-border" v-text="item.ip"></td>
                <td class="t-border">
                  <span class="t-border-btn" v-text="$t('common.delete')" @click="deleteMachine(item)"></span>
                  <span class="t-border-btn" v-text="$t('common.edit')" @click="editMachineAuth(item)"></span>
                </td>
              </tr>
            </tbody>
        </table>
      </el-form-item>
    </el-form>
    <!-- 仓库弹窗 -->
    <el-dialog :closeOnClickModal="false" 
      :title="$t('envauthority.addResource')" 
      :visible.sync="resourceDiaVis" 
      width="800px">
      <el-form ref="searchResourceForm" :inline="true" input-width="auto">
        <el-form-item>
          <el-select v-model="flagId" filterable>
            <el-option v-for="(item, key) in select_resource" :label="item" :value="key" :key="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" 
            @click="searchResourceList" 
            v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form>
      <el-table-extend
        :data="resourceTableData"
        :head="resourceTableHead"
        :currentChange="resourceCurrentChange"
        :sizeChange="resourceSizeChange"
        border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="resourceTableOperate" 
            :data="data" 
            :label="$t('envauthority.operate')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
      <table class="resource-dia-table" v-show="tempResourceData.length > 0">
        <thead>
          <tr>
            <th class="t-border" 
              v-for="(item, index) in tempResourceHead" 
              v-text="item"
              :key="index"
              v-show="index !== 'operate'"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in tempResourceData" :key="item.id">
            <td class="t-border" 
              v-for="(_item, index) in tempResourceHead"
              :key="index"
              v-show="index !== 'operate'"
              v-text="item[index]"></td>
          </tr>
        </tbody>
      </table>
      <div slot="footer">
        <el-button @click="resourceDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button @click="saveResource" v-text="$t('common.confirm')" type="primary"></el-button>
        <el-button @click="tempResourceData = []" v-text="$t('envauthority.clearAll')" type="primary"></el-button>
      </div>
    </el-dialog>
    <!-- 主机列表弹窗 -->
    <el-dialog :closeOnClickModal="false"
      :title="$t('envauthority.addHost')" 
      :visible.sync="hostDiaVis" 
      width="800px">
      <el-form ref="searchHostForm" :model="searchHostForm" :inline="true" input-width="auto">
        <el-form-item :label="$t('envauthority.department')">
          <g-select :list="select_group" v-model="searchHostForm.group" :default-all="true"></g-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchHostForm.ip" :placeholder="$t('envauthority.byIp')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" 
            @click="searchHostList(true)" 
            v-text="$t('common.search')"></el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" 
            @click="addCurrent" 
            v-text="$t('envauthority.addCurrentPage')"></el-button>
        </el-form-item>
      </el-form>
      <el-table-extend
        :data="hostTableData"
        :head="hostTableHead"
        :currentChange="hostCurrentChange"
        :sizeChange="hostSizeChange"
        border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="hostTableOperate" 
            :data="data" 
            :label="$t('envauthority.operate')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
      <div class="ip-dia-wrap" v-show="selectMachines.length > 0">
        <div class="each-ip" v-for="(item, index) in selectMachines" :key="item.ip + index">
          <i class="icon iconfont icon-amc_circle_close icon-delete" @click="selectMachines.splice(index, 1)"></i>
          <span v-text="item.ip"></span>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="hostDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button @click="saveMachine" v-text="$t('common.confirm')" type="primary"></el-button>
        <el-button @click="selectMachines = []" v-text="$t('envauthority.clearAll')" type="primary"></el-button>
      </div>
    </el-dialog>
    <!-- 权限弹窗 -->
    <el-dialog :closeOnClickModal="false"
      :title="$t('envauthority.editAuthority')" 
      :visible.sync="authDiaVis" 
      width="400px">
      <el-checkbox-group v-model="chooseAuth" :min="1">
        <el-checkbox v-for="auth in authList" :label="auth" :key="auth">{{ auth }}</el-checkbox>
      </el-checkbox-group>
      <div slot="footer">
        <el-button @click="authDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button @click="saveSingleAuth" v-text="$t('common.confirm')" type="primary"></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import resourceModelBiz from '@/logic/cmdb/resourceModelBiz'
  import repertoryBiz from '@/logic/cmdb/repertoryBiz'
  import envauthorityBiz from '@/logic/continuousDelivery/envauthorityBiz'
  import cmdbBiz from '@/logic/cmdb/cmdbBiz'
  let vm
  export default {
    mixins: [rac, dic, table],
    data () {
      vm = this
      return {
        history: [],
        saveForm: {
          group: '',
          name: ''
        },
        formRule: {
          group: [
            { required: true, message: this.$t('envauthority.groupTips') }
          ],
          name: [
            { required: true, message: this.$t('envauthority.nameTips') }
          ]
        },
        flagId: '',
        searchHostForm: {
          group: '',
          ip: ''
        },
        select_department: {},
        select_group: {},
        select_resource: {},
        resourceDiaVis: false,
        hostDiaVis: false,
        authDiaVis: false,
        authList: [this.$t('envauthority.onlyRead'), this.$t('envauthority.onlyWrite')],
        isHandlerResource: true,
        chooseAuth: [],
        chooseMachine: '',
        resourceTableHead: [],
        resourceTableData: [],
        tempResourceHead: {},
        tempResourceData: [],
        chooseResource: null,
        resourceList: [],
        resourceCurrentPage: 1,
        resourcePerPageCount: 10,
        resourceTableOperate: [{
          rac: () => this.gRac('handlerEnvauthority@addResource'),
          label: this.$t('envauthority.addTo'),
          callback: (row, index, data) => {
            let obj = {}
            this.resourceTableHead.map(item => {
              obj[item.key] = item.label
            })
            this.tempResourceHead = { ...obj, operate: this.$t('envauthority.operate') }
            if (this.tempResourceData.filter(item => item.id === row.id).length === 0) {
              this.tempResourceData.push({
                ...row,
                flagId: this.flagId,
                auth: ['1']
              })
            }
          }
        }],
        hostTableData: {},
        hostTableHead: [],
        hostCurrentPage: 1,
        hostPerPageCount: 10,
        hostTableOperate: [{
          rac: () => this.gRac('handlerEnvauthority@addMachines'),
          label: this.$t('envauthority.addTo'),
          callback: (row, index, data) => {
            if (this.selectMachines.filter(item => item.ip === row.ip1).length === 0) {
              this.selectMachines.push({
                auth: ['1'],
                ip: row.ip1
              })
            }
          }
        }],
        selectMachines: [],
        currentIpList: [],
        machinesList: []
      }
    },
    methods: {
      setHistory () {
        this.history = []
        this.history.push({ name: this.$route.query.id ? this.$t('envauthority.editAuthority')
          : this.$t('envauthority.addAuthority') })
      },
      openResourceDia () {
        this.tempResourceData = []
        this.resourceDiaVis = true
      },
      openHostDia () {
        this.selectMachines = []
        this.machinesList.map(item => {
          this.selectMachines.push(item)
        })
        this.hostDiaVis = true
      },
      async waitGroup () {
        await Promise.all([
          this.dGetDictionaryByCode('hostStatus'),
          this.dGetGroup()
        ])
        this.select_group = { ...this.dDictionaryGroup }
        this.searchHostList()
      },
      findAuthority () {
        envauthorityBiz.findAuthorityById({ id: this.$route.query.id }).then((data) => {
          this.saveForm.group = data.group
          this.saveForm.name = data.name
          let resourceList = []
          data.repository.map(item => {
            let parton = {}
            item.properties.map(_item => {
              if (_item.display) {
                parton[_item['property']] = _item['name']
              }
            })
            parton['operate'] = this.$t('common.handle')
            resourceList.push({
              flagId: item.flagId,
              data: item.authList,
              parton: parton
            })
          })
          this.resourceList = resourceList
          data.host.map((item) => {
            this.machinesList.push(item)
          })
        })
      },
      initTable () {
        this.hostTableHead = [
          { key: 'department', label: this.$t('envauthority.hostTable.group') },
          { key: 'hostName', label: this.$t('envauthority.hostTable.hostName') },
          { key: 'ip1', label: this.$t('envauthority.hostTable.ip1') },
          { key: 'status',
            label: this.$t('envauthority.hostTable.status'),
            formatter: 'Dictionary',
            formatterDic: this.dDictionary.hostStatus }
        ]
      },
      setResourceParton (propertyParam) {
        return resourceModelBiz.getProperty(propertyParam).then((data) => {
          this.resourceTableHead = []
          data.dataList.map((item) => {
            if (item.display && propertyParam.resourceType === '3') {
              this.resourceTableHead.push({ key: item.property, label: item.name })
            }
          })
        })
      },
      getResourceDic () {
        return resourceModelBiz.getResource().then((data) => {
          let obj = {}
          data.map((item) => {
            if (item.resourceType === '3') {
              obj[item.flagId] = item.resourceName
            }
          })
          this.select_resource = { ...obj }
          this.flagId = Object.keys(this.select_resource)[0]
        })
      },
      getResourceData () {
        return new Promise((resolve) => {
          this.getResourceDic().then(() => {
            this.setResourceData(resolve)
          })
        })
      },
      setResourceData (resolve) {
        this.setResourceParton({
          resourceType: '3',
          flagId: this.flagId
        }).then(() => {
          repertoryBiz.getInstance({
            resourceType: '3',
            flagId: this.flagId,
            currentPage: this.resourceCurrentPage,
            perPageCount: this.resourcePerPageCount
          }).then((data) => {
            this.resourceTableData = data
          })
          if (resolve) resolve()
        })
      },
      resourceCurrentChange (val) {
        this.resourceCurrentPage = val
        this.setResourceData()
      },
      resourceSizeChange (val) {
        this.resourceCurrentPage = 1
        this.resourcePerPageCount = val
        this.setResourceData()
      },
      saveAuth () {
        this.$refs['saveForm'].validate((valid) => {
          if (valid) {
            let saveObj = {
              repository: this.translateResource(),
              host: this.machinesList,
              ...this.saveForm
            }
            if (this.$route.query.id) {
              saveObj.id = this.$route.query.id
              envauthorityBiz.updateAuthority(saveObj).then(() => {
                this.saveSuccess()
              })
            } else {
              envauthorityBiz.save(saveObj).then(() => {
                this.saveSuccess()
              })
            }
          } else {
            return false
          }
        })
      },
      translateResource () {
        let resourceList = []
        this.resourceList.map(resourceItem => {
          if (resourceItem.data.length !== 0) {
            let authList = []
            resourceItem.data.map(authItem => {
              authList.push({
                id: authItem.id,
                auth: authItem.auth
              })
            })
            resourceList.push({
              flagId: resourceItem.flagId,
              authList: authList
            })
          };
        })
        return resourceList
      },
      saveSuccess () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.$router.push({ name: 'envauthority' })
      },
      searchResourceList () {
        this.tempResourceData = []
        this.resourceCurrentPage = 1
        this.resourcePerPageCount = 10
        this.setResourceData()
      },
      saveResource () {
        if (this.tempResourceData.length === 0) {
          this.resourceDiaVis = false
          return
        }
        if (this.resourceList.filter(item => item.flagId === this.flagId).length === 0) {
          this.resourceList.push({
            flagId: this.flagId,
            parton: this.tempResourceHead,
            data: this.tempResourceData
          })
        } else {
          let flagIndex = this.resourceList.findIndex(item => item.flagId === this.flagId)
          this.tempResourceData.map((item) => {
            if (this.resourceList[flagIndex].data.filter(_item => item.id === _item.id).length === 0) {
              this.resourceList[flagIndex].data.push(item)
            }
          })
        }
        this.resourceDiaVis = false
      },
      deleteResource (info) {
        let flagIndex = this.resourceList.findIndex(item => item.flagId === info.flagId)
        let deleteIndex = this.resourceList[flagIndex].data
          .findIndex(item => item.id === info.id)
        this.resourceList[flagIndex].data.splice(deleteIndex, 1)
        if (this.resourceList[flagIndex].data.length === 0) this.resourceList.splice(flagIndex, 1)
      },
      editResourceAuth (info) {
        this.isHandlerResource = true
        this.chooseResource = info
        this.setDefaultAuth(info)
        this.authDiaVis = true
      },
      searchHostList (fromClick = false) {
        if (fromClick) {
          this.hostCurrentPage = 1
          this.hostPerPageCount = 10
        }
        this.initTable()
        let searchObj = {
          currentPage: this.hostCurrentPage,
          perPageCount: this.hostPerPageCount
        }
        Object.keys(this.searchHostForm).map((item) => {
          if (this.searchHostForm[item]) {
            searchObj[item] = this.searchHostForm[item]
          }
        })
        cmdbBiz.hostList(searchObj).then((data) => {
          data.dataList.map(item => {
            if (item.group && item.group.length > 1) {
              item.group = item.group.join(',')
            }
          })
          this.currentIpList = []
          data.dataList.map(item => {
            this.currentIpList.push(item.ip1)
          })
          this.hostTableData = data
        }).catch((err) => {
          console.error(err)
        })
      },
      hostCurrentChange (val) {
        this.hostCurrentPage = val
        this.searchHostList()
      },
      hostSizeChange (val) {
        this.hostCurrentPage = 1
        this.hostPerPageCount = val
        this.searchHostList()
      },
      addCurrent () {
        this.currentIpList.map(item => {
          if (this.selectMachines.filter(_item => _item.ip === item).length === 0) {
            this.selectMachines.push({
              ip: item,
              auth: ['1']
            })
          }
        })
      },
      saveMachine () {
        this.machinesList = []
        this.selectMachines.map((item) => {
          if (this.machinesList.filter(_item => item.ip === _item.ip).length === 0) {
            this.machinesList.push(item)
          }
        })
        this.hostDiaVis = false
      },
      deleteMachine (info) {
        let index = this.machinesList.findIndex(item => item.ip === info.ip)
        this.machinesList.splice(index, 1)
      },
      editMachineAuth (info) {
        this.isHandlerResource = false
        this.chooseAuth = []
        this.chooseMachine = info.ip
        this.setDefaultAuth(info)
        this.authDiaVis = true
      },
      setDefaultAuth (info) {
        if (info.auth.length === 1 && info.auth[0] === '1') {
          this.chooseAuth = [this.$t('envauthority.onlyRead')]
        } else if (info.auth.length === 1 && info.auth[0] === '2') {
          this.chooseAuth = [this.$t('envauthority.onlyWrite')]
        } else {
          this.chooseAuth = [this.$t('envauthority.onlyRead'), this.$t('envauthority.onlyWrite')]
        }
      },
      saveSingleAuth () {
        let auth
        if (this.chooseAuth.length === 1 && this.chooseAuth[0] === this.$t('envauthority.onlyRead')) {
          auth = ['1']
        } else if (this.chooseAuth.length === 1 && this.chooseAuth[0] === this.$t('envauthority.onlyWrite')) {
          auth = ['2']
        } else {
          auth = ['1', '2']
        }
        if (this.isHandlerResource) {
          let flagIndex = this.resourceList.findIndex(item => item.flagId === this.chooseResource.flagId)
          let authIndex = this.resourceList[flagIndex].data
            .findIndex(item => item.id === this.chooseResource.id)
          this.resourceList[flagIndex].data[authIndex].auth = auth
        } else {
          let index = this.machinesList.findIndex(item => item.ip === this.chooseMachine)
          this.machinesList[index].auth = auth
        }
        this.authDiaVis = false
      },
      getDepartments () {
        repertoryBiz.getInstance({
          currentPage: 1,
          perPageCount: 999,
          flagId: 't_department',
          resourceType: '4'
        }).then(data => {
          let obj = {}
          data.dataList.map(item => {
            obj[item.name] = item.name
          })
          this.select_department = obj
        })
      },
      resetForm () {
        this.machinesList = []
        this.resourceList = []
        this.saveForm.group = ''
        this.saveForm.name = ''
        this.flagId = ''
        this.searchHostForm.group = ''
        this.searchHostForm.ip = ''
        this.hostCurrentPage = 1
        this.hostPerPageCount = 10
        this.resourceCurrentPage = 1
        this.resourcePerPageCount = 10
        this.setHistory()
        this.getDepartments()
        this.waitGroup()
        this.getResourceData()
      }
    },
    filters: {
      auth (value) {
        let lan = ''
        if (value.length === 1 && value[0] === '1') {
          lan = vm.$t('envauthority.onlyRead')
        } else if (value.length === 1 && value[0] === '2') {
          lan = vm.$t('envauthority.onlyWrite')
        } else {
          lan = `${vm.$t('envauthority.onlyRead')}、${vm.$t('envauthority.onlyWrite')}`
        }
        return lan
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'handlerEnvauthority' && from.name === 'envauthority') {
          if (to.query.id) {
            this.findAuthority()
          }
          this.resetForm()
        }
      }
    },
    mounted () {
      this.setHistory()
      this.getDepartments()
      this.waitGroup()
      this.getResourceData()
      if (this.$route.query.id) {
        this.findAuthority()
      }
    }
  }
</script>

<style scoped>
  .resource-dia-table {
    margin-top: 10px;
    overflow-x: auto;
    display: inline-block;
    width: 100%;
  }
  .ip-dia-wrap {
    border: 1px solid #ddd;
    width: 756px;
    margin: 8px auto;
  }
  .each-ip {
    width: 124px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    position: relative;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .each-ip:hover {
    background: #eaeaea;
    border: 1px solid #ddd;
  }
  .each-ip:hover .icon-delete {
    display: block;
  }
  .icon-delete {
    display: none;
    color: #a0a0a0;
    font-size: 18px;
    position: absolute;
    bottom: 20px;
    right: -8px;
  }
  .icon-delete:hover {
    color: #3385ff;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  .t-border {
    height: 30px;
    width: 110px;
    min-width: 84px;
    max-width: 150px;
    padding: 0 4px;
    border: 1px solid #ddd;
    text-align: center;
    font-weight: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .t-border-btn {
    color: #0B8DE5;
    cursor: pointer;
  }
  .t-border-btn:hover {
    color: #3ca4ea;
  }
</style>